// extracted by mini-css-extract-plugin
export default {"container":"cVjhD","logo-wrapper":"SBPMU"};